module.exports = __webpack_public_path__ + "static/img/bg_kangou.25562bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_kangou.png
// module id = XJZ9
// module chunks = 0